import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import entryGuideService from '../../services/entryGuideService';
import EntryGuideForm from '../../components/EntryGuides/EntryGuideForm';
import Toast from '../../components/Common/Toast';
import FormLoadingSpinner from '../../components/Common/FormLoadingSpinner';

const EditInitialGuide = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [entryGuide, setEntryGuide] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    const loadEntryGuide = async () => {
      try {
        setLoading(true);
        const response = await entryGuideService.getEntryGuide(id);
        if (response.success && response.data) {
          setEntryGuide(response.data);
        } else {
          setToast({ isOpen: true, message: 'No se pudo cargar la guía inicial', type: 'error' });
          setTimeout(() => navigate('/warehouses'), 2000); // Redirigir a selección de almacenes
        }
      } catch (error) {
        console.error('Error al cargar guía inicial:', error);
        setToast({ isOpen: true, message: 'Error al cargar la guía inicial', type: 'error' });
        setTimeout(() => navigate('/warehouses'), 2000);
      } finally {
        setLoading(false);
      }
    };
    loadEntryGuide();
  }, [id, navigate]);

  const handleSuccess = (updatedGuide) => {
    setToast({ isOpen: true, message: 'Guía inicial actualizada exitosamente', type: 'success' });
    setTimeout(() => {
      // Asumiendo que la guía tiene un warehouse_id para redirigir
      const warehouseId = updatedGuide?.warehouse_id || entryGuide?.warehouse_id;
      if (warehouseId) {
        navigate(`/warehouses/${warehouseId}/documents`);
      } else {
        navigate('/warehouses');
      }
    }, 1500);
  };

  if (!loading && !entryGuide) {
    return null;
  }

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Editar Guía Inicial</h1>
          <p className="text-gray-600 mt-1">Modifique la información de la guía inicial</p>
        </div>
        {loading ? (
          <FormLoadingSpinner message="Cargando guía…" hint="Obteniendo ítems y datos del almacén" />
        ) : (
        <EntryGuideForm
          isOpen={true}
          onClose={() => {
            const warehouseId = entryGuide?.warehouse_id;
            if (warehouseId) {
              navigate(`/warehouses/${warehouseId}/documents`);
            } else {
              navigate('/warehouses');
            }
          }}
          entryGuide={entryGuide}
          warehouseId={entryGuide.warehouse_id} // Asegurar que el warehouseId se pase
          onSuccess={handleSuccess}
          isPageMode={true}
          isInitial={true} // Indicar que es una guía inicial
        />
        )}
        <Toast isOpen={toast.isOpen} message={toast.message} type={toast.type} onClose={() => setToast({ ...toast, isOpen: false })} />
      </div>
    </div>
  );
};

export default EditInitialGuide;

